/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListUserSessionIssuerMcpServersResult,
  ListUserSessionIssuerMcpServersResult$inboundSchema,
} from "../components/listusersessionissuermcpserversresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListOrganizationUserSessionIssuerMcpServersSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListOrganizationUserSessionIssuerMcpServersRequest = {
  /**
   * The user_session_issuer whose attached MCP servers are listed.
   */
  userSessionIssuerId: string;
  /**
   * Pagination cursor: id of the last item from the previous page.
   */
  cursor?: string | undefined;
  /**
   * Page size (default 50, max 100).
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

export type ListOrganizationUserSessionIssuerMcpServersResponse = {
  result: ListUserSessionIssuerMcpServersResult;
};

/** @internal */
export type ListOrganizationUserSessionIssuerMcpServersSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListOrganizationUserSessionIssuerMcpServersSecurity$outboundSchema:
  z.ZodMiniType<
    ListOrganizationUserSessionIssuerMcpServersSecurity$Outbound,
    ListOrganizationUserSessionIssuerMcpServersSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listOrganizationUserSessionIssuerMcpServersSecurityToJSON(
  listOrganizationUserSessionIssuerMcpServersSecurity:
    ListOrganizationUserSessionIssuerMcpServersSecurity,
): string {
  return JSON.stringify(
    ListOrganizationUserSessionIssuerMcpServersSecurity$outboundSchema.parse(
      listOrganizationUserSessionIssuerMcpServersSecurity,
    ),
  );
}

/** @internal */
export type ListOrganizationUserSessionIssuerMcpServersRequest$Outbound = {
  user_session_issuer_id: string;
  cursor?: string | undefined;
  limit?: number | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListOrganizationUserSessionIssuerMcpServersRequest$outboundSchema:
  z.ZodMiniType<
    ListOrganizationUserSessionIssuerMcpServersRequest$Outbound,
    ListOrganizationUserSessionIssuerMcpServersRequest
  > = z.pipe(
    z.object({
      userSessionIssuerId: z.string(),
      cursor: z.optional(z.string()),
      limit: z.optional(z.int()),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        userSessionIssuerId: "user_session_issuer_id",
        gramSession: "Gram-Session",
      });
    }),
  );

export function listOrganizationUserSessionIssuerMcpServersRequestToJSON(
  listOrganizationUserSessionIssuerMcpServersRequest:
    ListOrganizationUserSessionIssuerMcpServersRequest,
): string {
  return JSON.stringify(
    ListOrganizationUserSessionIssuerMcpServersRequest$outboundSchema.parse(
      listOrganizationUserSessionIssuerMcpServersRequest,
    ),
  );
}

/** @internal */
export const ListOrganizationUserSessionIssuerMcpServersResponse$inboundSchema:
  z.ZodMiniType<ListOrganizationUserSessionIssuerMcpServersResponse, unknown> =
    z.pipe(
      z.object({
        Result: ListUserSessionIssuerMcpServersResult$inboundSchema,
      }),
      z.transform((v) => {
        return remap$(v, {
          "Result": "result",
        });
      }),
    );

export function listOrganizationUserSessionIssuerMcpServersResponseFromJSON(
  jsonString: string,
): SafeParseResult<
  ListOrganizationUserSessionIssuerMcpServersResponse,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListOrganizationUserSessionIssuerMcpServersResponse$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ListOrganizationUserSessionIssuerMcpServersResponse' from JSON`,
  );
}
